(function () {
  const CONFIG = window.uePromoBarConfig || {};
  const PREFIX_TEXT = CONFIG.prefix || "Free Shipping US $100+";
  const SUFFIX_TEXT = CONFIG.suffix || "GEAR DROP EVENT STARTS <strong>WED 12PM PT</strong>";
  const COUNTDOWN_TEXT = CONFIG.countdownText || "GEAR DROP EVENT:";
  const LIVE_TEXT = CONFIG.liveText || "GEAR DROP EVENT IS LIVE – SHOP NOW";
  const LIVE_LINK = CONFIG.liveLink || "https://urbanedc.com/collections/drop";
  const LINK_URL = CONFIG.link || "https://urbanedc.com/pages/never-miss-a-drop";

  // EDC-29 - early access bar
  const EARLY_ACCESS_ENABLED = CONFIG.earlyAccessEnabled !== false;
  const EARLY_ACCESS_TEXT = CONFIG.earlyAccessText || "Early Access Now Live \u2013 Join Now to Shop";
  const EARLY_ACCESS_LINK = CONFIG.earlyAccessLink || "/products/yamato-club?variant=40748943605853";

  const DROP_DAY = typeof CONFIG.dropDay !== "undefined" ? Number(CONFIG.dropDay) : 3;
  const DROP_HOUR = typeof CONFIG.dropHour !== "undefined" ? Number(CONFIG.dropHour) : 12;
  const DROP_MINUTE = typeof CONFIG.dropMinute !== "undefined" ? Number(CONFIG.dropMinute) : 0;

  function getPacificTime(date = new Date()) {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false
    }).formatToParts(date);

    const get = (type) => parts.find((p) => p.type === type).value;

    return new Date(
      `${get("year")}-${get("month").padStart(2, "0")}-${get("day").padStart(2, "0")}T${get("hour")
        .padStart(2, "0")}:${get("minute").padStart(2, "0")}:${get("second").padStart(2, "0")}`
    );
  }

  function getNextDropTime(nowPT) {
    const drop = new Date(nowPT);
    drop.setDate(nowPT.getDate() + ((DROP_DAY - nowPT.getDay() + 7) % 7));
    drop.setHours(DROP_HOUR, DROP_MINUTE, 0, 0);

    if (drop <= nowPT) {
      drop.setDate(drop.getDate() + 7);
    }

    return drop;
  }

  function getPromoState(nowPT) {
    const dropTime = getNextDropTime(nowPT);
    const diffMs = dropTime - nowPT;

    const diffHours = diffMs / (1000 * 60 * 60);

    const dropStartMinutes = DROP_HOUR * 60 + DROP_MINUTE;
    const currentMinutes = nowPT.getHours() * 60 + nowPT.getMinutes();

    const isLive =
      nowPT.getDay() === DROP_DAY &&
      currentMinutes >= dropStartMinutes;

    if (isLive) {
      return "live";
    }

    if (diffHours <= 24) {
      return "countdown";
    }

    return "next";
  }

  /**
   * Whether this shopper should be pitched early access instead of being shown
   * the countdown. window.customerHasEarlyAccess is set by layout/theme.liquid;
   * when it is missing we leave the normal bar alone rather than risk selling a
   * membership to somebody who already has one.
   */
  function shouldShowEarlyAccess() {
    return (
      EARLY_ACCESS_ENABLED &&
      typeof window.customerHasEarlyAccess !== "undefined" &&
      window.customerHasEarlyAccess !== true
    );
  }

  function neon(text) {
    return `<span class="uppercase neon-shadow">${text}</span>`;
  }

  function renderPromoBar() {
    const mount = document.querySelector("#announcement-promo-bar");
    if (!mount) return;

    const nowPT = getPacificTime();
    const state = getPromoState(nowPT);

    let message = "";
    const barClass =
      "announcement-bar flex flex-wrap justify-center items-center px-2 py-1 border-b text-center bg-cover uppercase";

    if (state === "live") {
      message = `
        <a href="${LIVE_LINK}" class="${barClass}">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none"><g filter="url(#a)"><path fill="#CD1000" d="M10.5 14.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm6.25-3.75a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0Zm-1.25 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0Z"/></g><path fill="#CD1000" d="M10.5 14.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm6.25-3.75a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0Zm-1.25 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0Z"/><defs><filter id="a" width="20.5" height="20.5" x=".25" y=".25" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_45_16" stdDeviation="2"/></filter></defs></svg>
          <span>&nbsp;${LIVE_TEXT}</span>
        </a>
      `;
    } else if (state === "countdown") {
      if (shouldShowEarlyAccess()) {
        message = `
          <a href="${EARLY_ACCESS_LINK}" class="early-access-bar" data-early-access-bar>
            ${EARLY_ACCESS_TEXT}
          </a>
        `;
      } else if (CONFIG.disableCountdown === true) {
        const baseText = `${PREFIX_TEXT}<span>&nbsp;|&nbsp;</span>${SUFFIX_TEXT}`;

        message = `
          <a href="${LINK_URL}" class="${barClass}">
            ${neon(baseText)}
          </a>
        `;
      } else {
        const dropTime = getNextDropTime(nowPT);
        const diff = dropTime - nowPT;
        const pad = (num) => String(num).padStart(2, "0");
        const hours = pad(Math.floor(diff / (1000 * 60 * 60)));
        const minutes = pad(Math.floor((diff / (1000 * 60)) % 60));
        const seconds = pad(Math.floor((diff / 1000) % 60));

        const baseText = `${PREFIX_TEXT}<span>&nbsp;|&nbsp;</span>${COUNTDOWN_TEXT} <strong>${hours}:${minutes}:${seconds}</strong>`;

        message = `
          <a href="${LINK_URL}" class="${barClass}">
            ${neon(baseText)}
          </a>
        `;
      }
   } else {
      const baseText = `${PREFIX_TEXT}<span>&nbsp;|&nbsp;</span>${SUFFIX_TEXT}`;

      message = `
        <a href="${LINK_URL}" class="${barClass}">
          ${neon(baseText)}
        </a>
      `;
    }

    mount.innerHTML = message;
  }

  function trackEarlyAccessClicks(mount) {
    mount.addEventListener("click", (event) => {
      const link = event.target.closest("[data-early-access-bar]");

      if (!link) return;

      event.preventDefault();

      const href = link.getAttribute("href");
      let navigated = false;
      const go = () => {
        if (navigated) return;
        navigated = true;
        window.location.href = href;
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "GA4event",
        "ga4-event-name": "cro_event",
        "ga4-event-p1-name": "event_category",
        "ga4-event-p1-value": "EDC29_PromoBarClick",
        "ga4-event-p2-name": "event_label",
        "ga4-event-p2-value": "",
        eventCallback: go,
        eventTimeout: 1200
      });

      // fallback in case eventCallback never fires
      setTimeout(go, 1200);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const mount = document.querySelector("#announcement-promo-bar");

    if (mount) {
      trackEarlyAccessClicks(mount);
    }

    renderPromoBar();
    if (!CONFIG.disableCountdown) {
      setInterval(renderPromoBar, 1000);
    }
  });
})();
